/**
 * MSAL's popup and silent sign-ins send Microsoft's answer back to this app, opened in a popup
 * or a hidden frame. That copy must hand the answer to the window that asked (MSAL listens on a
 * BroadcastChannel) instead of starting the app; without it those sign-ins only time out.
 */
export const isAuthResponseWindow = (win: Window = window): boolean => {
  const opened = win.opener !== null || win.self !== win.top;
  const answer =
    /(^|[#?&])state=/.test(win.location.hash) || /[?&]state=/.test(win.location.search);
  return opened && answer;
};
